package com.anjuros.website.templates.template1.sections

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.anjuros.website.components.language.LocalText
import com.anjuros.website.components.shared.AnjurosImage
import com.anjuros.website.components.shared.AnjurosText
import com.anjuros.website.templates.selection.components.contactform.ContactForm
import com.anjuros.website.templates.selection.components.contactform.ContactFormDetailsType
import com.anjuros.website.templates.selection.components.contactform.ContactFormInfo
import com.anjuros.website.templates.selection.components.contactform.MESSAGE_CONTACT_FORM
import com.anjuros.website.templates.selection.components.contactform.NAME_CONTACT_FORM
import com.anjuros.website.templates.selection.components.contactform.PHONE_NUMBER_CONTACT_FORM
import com.anjuros.website.templates.selection.components.contactform.SuccessContactMessage
import com.anjuros.website.templates.template1.components.Template1SectionTitle
import com.anjuros.website.templates.template1.modules.Template1Contact
import com.anjuros.website.templates.template1.modules.Template1Section
import com.anjuros.website.templates.template1.modules.Template1Theme
import com.anjuros.website.templates.template1.modules.getColor
import com.anjuros.website.templates.template1.modules.getColorOpacity
import com.anjuros.website.templates.template1.styles.Template1ContactFormStyle
import com.anjuros.website.templates.template1.styles.Template1ContactStyle
import com.anjuros.website.templates.template1.styles.Template1SectionPaddingStyle
import com.anjuros.website.templates.template1.util.ResKey
import com.anjuros.website.templates.template1.util.Template1ObserverViewportEntered
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.ObjectFit
import com.varabyte.kobweb.compose.css.TextDecorationLine
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.boxShadow
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.modifiers.letterSpacing
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxHeight
import com.varabyte.kobweb.compose.ui.modifiers.minHeight
import com.varabyte.kobweb.compose.ui.modifiers.objectFit
import com.varabyte.kobweb.compose.ui.modifiers.opacity
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.textDecorationLine
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.layout.SimpleGrid
import com.varabyte.kobweb.silk.components.layout.numColumns
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.rgb
import org.jetbrains.compose.web.css.rgba
import org.jetbrains.compose.web.css.times
import org.jetbrains.compose.web.dom.P

@Composable
fun Template1ContactSection(){
    Box(modifier = Template1SectionPaddingStyle.toModifier()
        .fillMaxWidth()
        .id(Template1Section.Contact.id)
        .backgroundColor(
            rgb(252, 248, 244)
        ),
        contentAlignment = Alignment.Center) {

        Template1ContactSectionContent( )
    }
}

@Composable
fun Template1ContactSectionContent() {


    Column(
        modifier = Modifier
            .fillMaxWidth(),
        verticalArrangement = Arrangement.Center,
        horizontalAlignment = Alignment.CenterHorizontally
    ) {

        Template1SectionTitle(
            badge = ResKey.TEMPLATE1_CONTACT_BADGE,
            title = ResKey.TEMPLATE1_CONTACT_TITLE,
            text = ResKey.TEMPLATE1_CONTACT_SUBTITLE
        )



            SimpleGrid(
                modifier = Modifier
                    .fillMaxWidth()
                    .margin(top=65.px)
                    .fillMaxWidth(),
                numColumns = numColumns(base = 1, lg=2)
            ) {

                Template1ContactDetails(
                    modifier = Modifier
                )


                Box(
                    modifier = Modifier
                ) {

                    // Your existing contact form
                    Template1ContactBox(modifier = Template1ContactFormStyle.toModifier()
                        .align(Alignment.Center))
                }
            }
    }
}


@Composable
private fun Template1ContactDetails(
    modifier: Modifier = Modifier
) {

    Box(
        modifier = modifier
    ) {

        AnjurosImage(
            modifier = Modifier
                .fillMaxWidth()
                .align(Alignment.Center)
                .minHeight(400.px)
                .maxHeight(700.px)
                .objectFit(ObjectFit.Cover),
            src = "template1_contactimage.jpg",
            alt = "Salon interior"
        )
        Template1ContactInfo(modifier = Modifier.align(Alignment.Center))
        // Dark organic shape containing contact information

    }
}


@Composable
private fun Template1ContactInfo(modifier: Modifier) {
    var opacity by remember { mutableStateOf(0.0f) }

    Template1ObserverViewportEntered(
        sectionId = "contactItems",
        distanceFromTop = 500.0,
        onViewportEnteredLambda = {
            opacity = 1.0f
        }
    )
    Column(
        modifier = modifier
            .id("contactItems")
            .backgroundColor(Template1Theme.DarkGreyOpacity.rgb)
            .padding(20.px)

    ) {

        SpanText(
            LocalText(
                ResKey.TEMPLATE1_CONTACT_SUBTITLE2
            ),
            Modifier
                .fontSize(13.px)
                .fontWeight(FontWeight.SemiBold)
                .letterSpacing(2.px)
                .margin(bottom = 15.px)
                .color(
                    Colors.White
                )
        )


        Template1Contact.entries.forEach { contact->
            Template1ContactInfoItem(
                contactItem = contact,
                opacity = opacity
            )
        }


    }
}


@Composable
private fun Template1ContactInfoItem(
    contactItem: Template1Contact,
    opacity: Float
) {

    Row(
        modifier = Modifier.margin(topBottom = 15.px)
            .opacity( opacity)
            .transition(Transition.of(property = "opacity",
                duration = 1200.ms,
                delay = 600.ms*contactItem.ordinal)),
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.Center
    ) {

        Box(
            modifier = Modifier
                .size(42.px)
                .borderRadius(50.percent)
                .margin(right = 10.px)
                .backgroundColor(
                    rgba(255, 255, 255, 0.12)
                ),
            contentAlignment = Alignment.Center
        ) {

            Image(
                modifier = Modifier
                    .size(22.px),
                src = contactItem.icon,
                alt = LocalText(contactItem.title)
            )
        }



        Column {

            SpanText(
                LocalText(contactItem.title),
                Modifier
                    .fontSize(14.px)
                    .fontWeight(FontWeight.SemiBold)
                    .letterSpacing(1.px)
                    .color(
                        rgba(255, 255, 255, 0.65)
                    )
            )


            Link(
                path = contactItem.path,
                modifier = Template1ContactStyle.toModifier().textDecorationLine(TextDecorationLine.None)
            ) {
                P(
                    attrs = Modifier
                        .fontSize(18.px)
                        .margin(top = 3.px)
                        .margin(topBottom = 0.px)
                        .toAttrs()
                ) {
                    AnjurosText(contactItem.text)
                }
            }
        }
    }
}

@Composable
fun Template1ContactBox(
    modifier: Modifier = Modifier

) {
    var success by remember { mutableStateOf(false) }


    Box(
        modifier = modifier
            .padding(20.px)
            .border(

                width = 1.px,
                color = Template1Theme.OpacityPrimary.getColor(),
                style = LineStyle.Solid)
            .boxShadow(
                offsetY = 12.px,
                blurRadius = 35.px,
                color = rgba(0, 0, 0, .5)
            )
          ,
        contentAlignment = Alignment.Center
    ) {


        ContactForm(
            isDemo = true,
            buttonColor = Template1Theme.Primary.getColor(),
            spamProtectionBackgroundColor = Template1Theme.Primary.getColor(),
            spamProtectionColor = Template1Theme.LightGray.rgb,
            spamShieldColor = "#EDEDED",
            contactItemsList = listOf(
                NAME_CONTACT_FORM.copy(index = 0),
                PHONE_NUMBER_CONTACT_FORM.copy(index = 1),
                MESSAGE_CONTACT_FORM.copy(index = 2),
                ContactFormInfo(
                    index=3,
                    type = ContactFormDetailsType.DATE_PICKER,
                    placeholderText = com.anjuros.website.components.language.ResKey.CONTACT_DATE,
                    labelText = com.anjuros.website.components.language.ResKey.CONTACT_DATE_LABEL,
                    nameText = "Preferred appointment date",
                    required = false,
                    validations = listOf()
                )
            )
        ) {
            success = true
        }
        SuccessContactMessage(
            isDemo = true,
            showSuccess = success,
            onClose = { success = false }
        )
    }
}




